import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModelVariant from './ModelVariant';
import { getModelVariantManager, getUserProfileWidget, getModelManager, getUserOrgModelCategoryType } from '../../selectors/index';
import {
  postModelVariantThunk,
  describeModelVariantThunk,
  setModelVariantChangeThunk,
  
} from '../../actions/modelVariant';
import { describeModelThunk } from '../../actions/model';

const mapStateToProps = state => {
  return {
    modelManager: getModelManager(state),
    modelVariantManager: getModelVariantManager(state),
    userProfileWidgets: getUserProfileWidget(state),
    userModelCategories: getUserOrgModelCategoryType(state)
    
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      saveModelVariant: (modelVariant, widgetCode) => postModelVariantThunk(modelVariant, widgetCode),
      describeModelVariant: (modelVariantId, isDuplicate, widgetCode, modelCategoryId) => describeModelVariantThunk(modelVariantId, isDuplicate, widgetCode, modelCategoryId),
      changeModelVariant: selectedModelVariant => setModelVariantChangeThunk(selectedModelVariant),
      describeModel: (modelId, widgetCode, modelCategoryId) => describeModelThunk(modelId, null, widgetCode, modelCategoryId)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelVariant);
